import React, { Component } from 'react';
import {
  USER_ROLE_ADMIN,
} from 'common/userRoles';

import { SCREEN_ID_ADMIN_FINANCE_LOCATOR_COMMISSIONS } from 'client/constants/screenIds';
import allowedRoles from 'client/helpers/allowedRoles';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

import SrPage from 'client/components/SrPage';
import SrH1 from 'client/components/SrH1';

import SrDataTableLocatorCommissions from 'client/components/financeAdmin/SrDataTableLocatorCommissions';

@withTransitionHook
@allowedRoles({
  roles: [
    USER_ROLE_ADMIN,
  ],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withScreenId(SCREEN_ID_ADMIN_FINANCE_LOCATOR_COMMISSIONS)
@withScrollToTop
class FinancesLocatorCommissionsPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Finances - Locator Commissions | Sunroom Rentals',
  })

  render() {
    return (
      <SrPage
        navbarProps={{
          redirectLogoTo: '/admin',
          backButtonLink: '/admin',
        }}
      >
        <div className='width-90'>
          <SrH1>locator commissions</SrH1>
          <SrDataTableLocatorCommissions />
        </div>
      </SrPage>
    );
  }
}

FinancesLocatorCommissionsPage.displayName = 'FinancesLocatorCommissionsPage';

export default FinancesLocatorCommissionsPage;
